// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/circuit-joining-controlled.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/circuit-joining-controlled/circuit-joining-controlled.js';

mount([g0]);
